/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendars_BlurbInputs */

const en_settings_calendars_blurb = /** @type {(inputs: Settings_Calendars_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick which calendars become lessons. If none are selected, the default calendar is used.`)
};

const he_settings_calendars_blurb = /** @type {(inputs: Settings_Calendars_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחר אילו יומנים הופכים לשיעורים. אם לא נבחר אף אחד, נעשה שימוש ביומן ברירת המחדל.`)
};

/**
* | output |
* | --- |
* | "Pick which calendars become lessons. If none are selected, the default calendar is used." |
*
* @param {Settings_Calendars_BlurbInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_calendars_blurb = /** @type {((inputs?: Settings_Calendars_BlurbInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendars_BlurbInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendars_blurb(inputs)
	return he_settings_calendars_blurb(inputs)
});